import { render } from "./Input.vue?vue&type=template&id=c961a936&scoped=true"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"

import "./Input.vue?vue&type=style&index=0&id=c961a936&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-c961a936"

export default script